import React from 'react';
import styles from './CourseRating.module.scss';

interface CourseRatingProps {
    reviewsCount: number;
    avgCourseRating: number;
}

function CourseRating(props:CourseRatingProps) {
  const courseRating = Number(props.avgCourseRating).toFixed(1);
  return (
    <div className="d-flex align-items-center">
      <div className={`${styles.ratingContainer}`}>
        <div className={`${styles.stars} ${styles.empty}`} />
        <div
          className={`${styles.stars} ${styles.filled}`}
          style={{ '--rating': courseRating } as React.CSSProperties}
          aria-label={`Rating of this course is ${courseRating} out of 5.`}
        />
      </div>
      <div className="h5 ml-1 mr-3 mb-0">{courseRating} stars</div>
      <div className="micro">{props.reviewsCount} ratings</div>
    </div>
  );
}

export default CourseRating;
